import React, {useEffect, useRef} from 'react';
import PropTypes from 'prop-types';

import './custom_dropdown.scss';

/**
 * @deprecated Use DROPDOWN_OPEN_EVENT_NAME
 */
export const DROPDOWN_TRIGGER_NAME = 'mindsets-dropdown-open-';
export const DROPDOWN_OPEN_EVENT_NAME = 'mindsets-dropdown-open-';
export const DROPDOWN_CLOSE_EVENT_NAME = 'mindsets-dropdown-close-';

const uniq_id = Date.now() + '-' + Math.floor(Math.random() * 100);

function CustomDropdown(
    {
        id,
        trigger,
        items,
        selected,
        container_class = '',
        trigger_class = '',
        content_class = '',
        item_class = '',
        open_on_mouse_over = false,
        close_on_mouse_leave = false,
        no_wrap = false,
        disabled = false,
        before_trigger,
        after_trigger,
        onOpen,
        onClose
    }
) {
    const triggerRef = useRef();
    const contentRef = useRef();
    const containerRef = useRef();

    function onTrigger() {
        if (!disabled && !contentRef.current.classList.contains('open')) {
            contentRef.current.classList.add('open');
            position();
        } else if (contentRef.current.classList.contains('open')) {
            contentRef.current.classList.remove('open');
        }
    }

    function onOpenHandler() {
        if (!disabled && !contentRef.current.classList.contains('open')) {
            contentRef.current.classList.add('open');
            position();
            if (typeof onOpen === 'function') {
                onOpen();
            }
        }
    }

    function onCloseHandler() {
        if (contentRef.current.classList.contains('open')) {
            contentRef.current.classList.remove('open');
        }
        if (typeof onClose === 'function') {
            onClose();
        }
    }

    function onOutsideClick(event) {
        function getAllChildren(htmlElement) {
            if (!htmlElement) {
                return;
            }
            if (htmlElement.children.length === 0) return [htmlElement];

            let allChildElements = [];

            for (let i = 0; i < htmlElement.children.length; i++) {
                let children = getAllChildren(htmlElement.children[i]);
                if (children) allChildElements.push(...children);
            }
            allChildElements.push(htmlElement);

            return allChildElements;
        }

        const targetClasses = [...event.target.classList];
        if (!event.target.matches('#' + 'mindsets-dropdown-trigger-' + uniq_id)) {
            const children = getAllChildren(triggerRef.current);
            if (children) {
                let classes = [];
                let i;
                for (i = 0; i < children.length; i++) {
                    classes = classes.concat([...children[i].classList])
                }
                const filteredArray = classes.filter(value => targetClasses.includes(value));
                if (filteredArray.length <= 0 && contentRef.current.classList.contains('open')) {
                    onCloseHandler();
                }
            }
        }
        event.stopPropagation();
    }

    function position() {
        const dropdownContent = contentRef.current;
        if (dropdownContent) {
            const dropdownContentRect = dropdownContent.getBoundingClientRect();
            // Constrain width
            if (no_wrap === true) {
                dropdownContent.style.whiteSpace = 'nowrap';
            } else {
                dropdownContent.style.whiteSpace = null;
            }
            const body = document.getElementsByTagName('body')[0];
            if ((dropdownContentRect.x + dropdownContent.offsetWidth) >= body.offsetWidth && dropdownContentRect.left >= 0) {
                dropdownContent.style.right = '0';
            } else {
                dropdownContent.style.right = null;
            }
            // if ((dropdownContentRect.y + dropdownContent.offsetHeight) >= body.offsetHeight && dropdownContentRect.top >= 0) {
            //     dropdownContent.style.bottom = '0';
            // } else {
            //     dropdownContent.style.bottom = null;
            // }
        }
    }

    function getContainerClassName() {
        return "mindsets-dropdown-container " + container_class;
    }

    function getTriggerClassName() {
        return "mindsets-dropdown-trigger " + trigger_class + (disabled ? ' disabled' : '');
    }

    function getContentClassName() {
        return " mindsets-dropdown-content " + content_class;
    }

    function onMouseEnter() {
        if (open_on_mouse_over) {
            onOpenHandler();
        }
    }

    function onMouseLeave() {
        if (close_on_mouse_leave) {
            onCloseHandler();
        }
    }

    useEffect(() => {
        position();
        window.addEventListener('resize', position);
        window.addEventListener('click', onOutsideClick);
        const container = containerRef.current;
        container.addEventListener('mouseenter', onMouseEnter);
        container.addEventListener('mouseleave', onMouseLeave);
        if (id) {
            window.addEventListener(DROPDOWN_OPEN_EVENT_NAME + id, onOpenHandler);
            window.addEventListener(DROPDOWN_CLOSE_EVENT_NAME + id, onCloseHandler);
        }

        return () => {
            window.removeEventListener('resize', position);
            window.removeEventListener('click', onOutsideClick);
            container.removeEventListener('mouseenter', onMouseEnter);
            container.removeEventListener('mouseleave', onMouseLeave);
            if (id) {
                window.removeEventListener(DROPDOWN_OPEN_EVENT_NAME + id, onOpenHandler);
                window.removeEventListener(DROPDOWN_CLOSE_EVENT_NAME + id, onCloseHandler);
            }
        }
    }, []);

    return (
        <div className={getContainerClassName()} ref={containerRef}>
            {before_trigger}
            <div
                className={getTriggerClassName()}
                onClick={event => {
                    onTrigger();
                    event.stopPropagation();
                }}
                id={'mindsets-dropdown-trigger-' + uniq_id}
                ref={triggerRef}
            >
                {trigger}
            </div>
            {after_trigger}
            <ul
                className={getContentClassName()}
                ref={contentRef}
            >
                {Object.keys(items).map(key => <li
                    key={key}
                    className={item_class + ' mindsets-dropdown-content-item ' + (selected === key ? 'active' : '')}
                >{items[key]}</li>)}
            </ul>
        </div>
    );
}

CustomDropdown.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    trigger: PropTypes.element.isRequired,
    items: PropTypes.objectOf(PropTypes.element).isRequired,
    selected: PropTypes.string,
    container_class: PropTypes.string,
    trigger_class: PropTypes.string,
    content_class: PropTypes.string,
    item_class: PropTypes.string,
    open_on_mouse_over: PropTypes.bool,
    close_on_mouse_leave: PropTypes.bool,
    no_wrap: PropTypes.bool,
    disabled: PropTypes.bool,
    before_trigger: PropTypes.any,
    after_trigger: PropTypes.any,
    onOpen: PropTypes.func,
    onClose: PropTypes.func
}

export default CustomDropdown
